import React from "react";
import PropTypes from "prop-types";

import { UIModal } from "../../../ui";
import ClientReportFileRow from "./ClientReportFileRow";
import { formatClientReportDate } from "./clientReportMappers";

import "./ClientReports.scss";

/** Destructive confirmation before permanently deleting a client report. */
const DeleteClientReportModal = ({
  open,
  labels,
  report,
  deleting,
  onClose,
  onConfirm,
}) => (
  <UIModal
    open={open}
    type="destructive"
    title={labels.title}
    cancelLabel={labels.cancel}
    confirmLabel={labels.confirm}
    onClose={deleting ? undefined : onClose}
    onCancel={onClose}
    onConfirm={() => onConfirm(report)}
    cancelButtonProps={{ disabled: deleting }}
    confirmButtonProps={{ disabled: deleting, loading: deleting }}
    disableEscapeKeyDown={deleting}
    showClose={false}
    maxWidth="sm"
    fullWidth
    PaperProps={{ className: "client-report-delete-modal" }}
  >
    {report ? (
      <div className="client-report-modal__body">
        <ClientReportFileRow
          title={report.name}
          subtitle={
            report.date
              ? labels.uploadedOn.replace(
                  "{date}",
                  formatClientReportDate(report.date),
                )
              : null
          }
          fileType={report.fileType}
        />
        <p className="client-report-modal__confirm-text text-body-sm">
          {labels.warning} {labels.confirmQuestion}
        </p>
      </div>
    ) : null}
  </UIModal>
);

DeleteClientReportModal.propTypes = {
  open: PropTypes.bool.isRequired,
  labels: PropTypes.shape({
    title: PropTypes.node.isRequired,
    cancel: PropTypes.node.isRequired,
    confirm: PropTypes.node.isRequired,
    uploadedOn: PropTypes.string.isRequired,
    warning: PropTypes.node.isRequired,
    confirmQuestion: PropTypes.node.isRequired,
  }).isRequired,
  report: PropTypes.object,
  deleting: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

DeleteClientReportModal.defaultProps = {
  report: null,
  deleting: false,
};

export default DeleteClientReportModal;
